import React, { useState, useEffect } from 'react';

const PAGE_SIZE_OPTIONS = [5, 20, 50, 100, 500, 'all'];

const btnStyle = (disabled) => ({
  padding: '4px 10px',
  borderRadius: '4px',
  border: '1px solid #ddd',
  backgroundColor: disabled ? '#f5f5f5' : 'white',
  color: disabled ? '#aaa' : '#333',
  cursor: disabled ? 'default' : 'pointer',
  fontSize: '14px',
  lineHeight: '1.4'
});

const TableWithPagination = ({ data }) => {
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
  }, [data]);

  if (!data || data.length === 0) return null;

  const cols = Object.keys(data[0]);
  const totalRows = data.length;
  const showAllRows = pageSize === 'all';
  const totalPages = showAllRows ? 1 : Math.max(1, Math.ceil(totalRows / pageSize));
  const startIdx = showAllRows ? 0 : (currentPage - 1) * pageSize;
  const endIdx = showAllRows ? totalRows : Math.min(startIdx + pageSize, totalRows);
  const pageData = showAllRows ? data : data.slice(startIdx, endIdx);

  const handlePageSizeChange = (e) => {
    const value = e.target.value;
    setPageSize(value === 'all' ? 'all' : Number(value));
    setCurrentPage(1);
  };

  return (
    <div style={{ width: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap', gap: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '13px', color: '#555' }}>Baris per halaman:</span>
          <select
            value={pageSize}
            onChange={handlePageSizeChange}
            style={{ padding: '4px 8px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '13px' }}
          >
            {PAGE_SIZE_OPTIONS.map(n => (
              <option key={n} value={n}>
                {n === 'all' ? 'Semua' : n}
              </option>
            ))}
          </select>
        </div>
        <span style={{ fontSize: '13px', color: '#555' }}>
          {startIdx + 1}–{endIdx} dari {totalRows} baris
        </span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1} style={btnStyle(currentPage === 1)}>«</button>
          <button onClick={() => setCurrentPage(p => p - 1)} disabled={currentPage === 1} style={btnStyle(currentPage === 1)}>‹</button>
          <span style={{ padding: '4px 12px', fontSize: '13px' }}>
            {currentPage} / {totalPages}
          </span>
          <button onClick={() => setCurrentPage(p => p + 1)} disabled={currentPage === totalPages} style={btnStyle(currentPage === totalPages)}>›</button>
          <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} style={btnStyle(currentPage === totalPages)}>»</button>
        </div>
      </div>

      <div style={{ overflowX: 'auto', width: '100%' }}>
        <table className="data-table" style={{ whiteSpace: 'nowrap' }}>
          <thead>
            <tr>
              <th>#</th>
              {cols.map(col => <th key={col}>{col}</th>)}
            </tr>
          </thead>
          <tbody>
            {pageData.map((row, i) => (
              <tr key={i}>
                <td>{startIdx + i + 1}</td>
                {cols.map(col => <td key={col}>{String(row[col] ?? '')}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableWithPagination;
